import { debugLogTime } from "../utils/common";

export const SET_SELECTED_REPORT = "selected.REPORT";
export const SET_SELECTED_DASHBOARD = "selected.DASHBOARD";
export const UPDATE_SELECTION_TABLE_PREFERENCES = "loadingState.UPDATE_SELECTION_TABLE_PREFERENCES";

export function setSelectedReport(report) {
  debugLogTime("setSelectedReport", report, "actions");

  return {
    type: SET_SELECTED_REPORT,
    report,
  };
}

export function setSelectedDashboard(dashboard) {
  debugLogTime("setSelectedDashboard", dashboard, "actions");

  return {
    type: SET_SELECTED_DASHBOARD,
    dashboard,
  };
}

export function updateSelectionPreferences(selectionPreferences) {
  debugLogTime("updateSelectionPreferences", selectionPreferences, "actions");

  return {
    type: UPDATE_SELECTION_TABLE_PREFERENCES,
    selectionPreferences,
  };
}
